import * as React from 'react'
import type { PlantEquipment } from '@axilon-apps/domains-ontology-ui-state'
import { SectionHeader } from '../entity/SectionHeader'
import { PlantHref } from '../PlantHref'
import { SessionEntityMark } from '../session-mark-ui'

export function PhysicalConnectionsSection({
  connections
}: {
  connections: PlantEquipment[]
}): React.ReactElement | null {
  if (connections.length === 0) return null

  return (
    <section>
      <SectionHeader
        label="Physical connections"
        subtitle={`${connections.length} ${connections.length === 1 ? 'peer' : 'peers'}`}
      />
      <div className="rounded-xl border bg-card p-5 text-card-foreground shadow-sm">
        <div className="flex flex-col gap-1.5">
          {connections.map((peer) => (
            <div key={peer.id} className="flex min-w-0 items-center gap-2">
              <PlantHref
                id={peer.id}
                label="Equipment"
                node={peer}
                className="min-w-0 flex-1 truncate text-13 font-medium text-ink no-underline hover:text-brand hover:underline"
                title={peer.id}
              >
                {peer.name}
              </PlantHref>
              <SessionEntityMark entityId={peer.id} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
